export var GrammaticalGender;
(function (GrammaticalGender) {
    GrammaticalGender["MASCULINE"] = "MASCULINE";
    GrammaticalGender["FEMININE"] = "FEMININE";
})(GrammaticalGender || (GrammaticalGender = {}));
